/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Images
import bgFront from "assets/images/rotating-card-bg-front.jpeg";
import bgBack from "assets/images/rotating-card-bg-back.jpeg";
import MKTypography from "../../../components/MKTypography";

function Introduction() {
  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                icon="touch_app"
                title={
                  <>
                    Welcome to the
                    <br />
                    Digital Nagar Profile
                  </>
                }
                description="All the MUI components that you need in a development have been re-design with the new look."
              />
              <RotatingCardBack
                image={bgBack}
                title="Discover More"
                description="You will save a lot of time going from prototyping to full-functional code because all elements are implemented."
                action={{
                  type: "internal",
                  route: "/sections/page-sections/page-headers",
                  label: "start with header",
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
            <MKBox position="sticky" top="100px" pb={{ xs: 2, lg: 6 }}>
              <MKTypography variant="h3" fontWeight="bold" mb={1}>
                Hariwon Municipality System
              </MKTypography>
              <MKTypography variant="body2" fontWeight="regular" color="secondary" mb={1} pr={2}>
                हरिवनको नामाकरणको सन्दर्भमा ऐतिहासिक तथा धार्मिक पृष्ठभूमिका अनुसार विभिन्न
                किवंदन्ती पाईन्छ । प्रथमतः प्राचीन कालमा राजा जनकका भाइ सुभाउ जनकले हालको वडा नं ९
                मा एउटा पोखरी खनेका थिए । त्यसताका उक्त पोखरीमा सयौंका संख्यामा हरिणहरु चर्दै पानी
                पिउने ठाउँ भएकोले हरणबाट हरिवन भएको, दाेस्रो भगवानको नाम हरि ओमबाट हरिवन भएको,
                तेस्रो हालको सिन्धुली जिल्लाको धिमालेको चुरेमा रहेको बस्तीबाट दक्षिण समथल भूभागमा
                हेर्दा हजारौं दुरी सम्म हरियो वन देखिने भएकोले पछि अपभ्रंस भई हरिवन भएको भन्ने रहेको
                छ । यसर्थ हरिण, हरिओम र हरियो वन जस्ता शब्दहरु अपभ्रंश भई विस्तारै हरिऔन हुँदै हरिवन
                नामाकरण भएको जनविश्वस रहेको छ ।

                हरिवनको नामाकरणको सन्दर्भमा ऐतिहासिक तथा धार्मिक पृष्ठभूमिका अनुसार विभिन्न
                किवंदन्ती पाईन्छ । प्रथमतः प्राचीन कालमा राजा जनकका भाइ सुभाउ जनकले हालको वडा नं ९
                मा एउटा पोखरी खनेका थिए । त्यसताका उक्त पोखरीमा सयौंका संख्यामा हरिणहरु चर्दै पानी
                पिउने ठाउँ भएकोले हरणबाट हरिवन भएको, दाेस्रो भगवानको नाम हरि ओमबाट हरिवन भएको,
                तेस्रो हालको सिन्धुली जिल्लाको धिमालेको चुरेमा रहेको बस्तीबाट दक्षिण समथल भूभागमा
                हेर्दा हजारौं दुरी सम्म हरियो वन देखिने भएकोले पछि अपभ्रंस भई हरिवन भएको भन्ने रहेको
                छ । यसर्थ हरिण, हरिओम र हरियो वन जस्ता शब्दहरु अपभ्रंश भई विस्तारै हरिऔन हुँदै हरिवन
                नामाकरण भएको जनविश्वस रहेको छ ।

              </MKTypography>
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Introduction;
